import { createSelector } from "@ngrx/store";
import { appState } from "src/app/shared/interfaces/appState.interface";

export const selectOrderState = (state: appState) => state.order;
export const selectControlPanelState = (state: appState) => state.controlPanel;

export const selectAllOrders = createSelector(
  selectOrderState,
  (orderState) => orderState.orderBoard.all
);

export const selectAllControlPanelOrders = createSelector(
  selectControlPanelState,
  (controlPanelState) => controlPanelState.controlPanelBoard.all
);